import React from "react";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import {makeStyles} from "@material-ui/core/styles";
import style from "../../assets/jss/disal-main/components/Modal";
import { useGerencia } from "../../Context/GerenciaContext";

const useStyles = makeStyles(style);

const ModalDelete = () => {
  const classes = useStyles();

  const { 
    deleteItem,
    setDeleteItem,
    doDelete,
  } = useGerencia();

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={deleteItem !== null}
      onClose={() => setDeleteItem(null)}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}
    >
    <Fade in={deleteItem !== null}>
      <div className={classes.paper} style={{ width: "500px" }}>
        <div className="modal-confirm">
          <h3>Confirmación</h3>
          <p>¿Estás seguro que quieres eliminar esta gerencia?</p>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn-modal-salida"
            style={{ textDecoration: "underline", marginRight: "10px" }}
            onClick={() => setDeleteItem(null)}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="btn-modal-salida"
            style={{ textDecoration: "underline" }}
            onClick={() => doDelete()}
          >
            Confirmar
          </button>
        </div>
      </div>
    </Fade>
  </Modal>
  )
}

export default ModalDelete;